import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import {
  Permissions,
  UserPermissions,
  hasPermissionForListId,
} from '®shared/permissions';
import { EditableList, ReadingListDetails } from '®shared/reading-list';

import { getListStatus } from './list-status-utils';

export enum ListStatus {
  draft = 'draft',
  published = 'published',
  publishedWithUnpublishedChanges = 'publishedWithUnpublishedChanges',
  archived = 'archived',
}

@Component({
  selector: 'rl-list-status',
  templateUrl: './list-status.component.html',
  styleUrls: ['./list-status.component.scss'],
})
export class ListStatusComponent implements OnInit, OnChanges {
  @Input() permissions: UserPermissions;
  @Input() list: ReadingListDetails;
  @Input() editableList?: EditableList;

  listStatus: string;
  hasEditListPermission = false;
  listStatusConstants = ListStatus;

  ngOnInit(): void {
    this.listStatus = getListStatus(this.list, this.editableList);
    this.hasEditListPermission = hasPermissionForListId(
      Permissions.EDIT_LIST,
      this.list.id,
      this.permissions,
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.editableList) {
      this.listStatus = getListStatus(this.list, this.editableList);
    }
  }
}
